import { render, staticRenderFns } from "./LongLabelsClearable.vue?vue&type=template&id=21106b6a"
import script from "./LongLabelsClearable.vue?vue&type=script&lang=js"
export * from "./LongLabelsClearable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports